import {
  GenerateLoadingOrError,
} from "@/lib/utils";
import { useListBaseOpenContracts, useListAccounts } from "@/lib/api/otc";
import { useListCustomers } from "@/lib/api/customer";
import { OtcContractContent } from "./components/OtcContractContent";

export function ContractsOtcDashboard() {
  // Fetch unstaged contracts
  const contractsRes = useListBaseOpenContracts({
    staged_for_review: false,
    filters: {},
  });

  // Fetch staged contracts
  const stagedContractsRes = useListBaseOpenContracts({
    staged_for_review: true,
    filters: {},
  });

  // Fetch customers
  const customersRes = useListCustomers();

  // Fetch accounts
  const accountsRes = useListAccounts(false);

  const loadingOrErrorUi = GenerateLoadingOrError([
    contractsRes,
    stagedContractsRes,
    customersRes,
    accountsRes,
  ]);

  if (loadingOrErrorUi) {
    return (
      <section className="flex min-h-full flex-1 flex-col justify-start px-6 py-6 lg:px-8">
        {loadingOrErrorUi}
      </section>
    );
  }

  const contracts = contractsRes?.data?.data || [];
  const stagedContracts = stagedContractsRes?.data?.data || [];
  const customers = customersRes?.data?.data || [];
  const accounts = accountsRes?.data?.data || [];

  return (
    <OtcContractContent
      showTitle={false}
      contracts={contracts}
      stagedContracts={stagedContracts}
      customers={customers}
      accounts={accounts}
      refetchContracts={() => {
        contractsRes.refetch();
        stagedContractsRes.refetch();
      }}
    />
  );
}
